import { Component, inject } from '@angular/core';
import { BaseDialogComponent } from '@cumlaude/shared-components-dialogs';
import { IconComponent } from '@cumlaude/shared-components-icons';
import { FeedbackDialogComponent } from '../feedback-dialog/feedback-dialog.component';
import { Dialog, DialogRef } from '@angular/cdk/dialog';
import { ENV_CONFIG, EnvConfiguration } from '@cumlaude/shared-configuration';
import { RestService } from '@cumlaude/shared-services';
import { lastValueFrom } from 'rxjs';
import { ToastrService } from '@cumlaude/shared-components-toast';

@Component({
	selector: 'app-feedback-menu-dialog',
	templateUrl: './feedback-menu-dialog.component.html',
	styleUrls: ['./feedback-menu-dialog.component.scss'],
	imports: [BaseDialogComponent, IconComponent],
})
export class FeedbackMenuDialogComponent {
	private readonly dialog = inject(Dialog);
	private readonly restService = inject(RestService);
	private readonly toastr = inject(ToastrService);
	protected readonly envConfig = inject<EnvConfiguration>(ENV_CONFIG);
	protected readonly dialogRef = inject<DialogRef<void>>(DialogRef);

	async openProductboard() {
		let productboardToken: string | undefined;
		try {
			productboardToken = await lastValueFrom(this.restService.getProductboardToken());
		} catch (error) {
			console.error('Failed to fetch Productboard token:', error);
			this.toastr.error('Inloggen voor het ideeënbord is mislukt. Neem contact op met je CumLaude-beheerder.');
			return;
		}

		window.open(`${this.envConfig.productboardLink}?token=${productboardToken}`, '_blank');
		this.dialogRef.close();
	}

	openFeedbackDialog() {
		this.dialog.open(FeedbackDialogComponent);
		this.dialogRef.close();
	}
}
